import {
  USER_MESSAGE_NOTIFICATIONS_ENDPOINT
} from '../../config/constants'

import firedux from '../firedux'
import {getState, dispatch} from '../store'

import setNewMessageNotification from '../actions/set_new_message_notification'

const onNotification = (snapshot) => {
  if (!snapshot.exists()) return

  const notification = snapshot.val()
  const key = snapshot.key()
  dispatch(setNewMessageNotification(notification, key))
}

export const watchNotifications = (uid) => {
  const MESSAGE_ENDPOINT = USER_MESSAGE_NOTIFICATIONS_ENDPOINT(uid)

  firedux.ref.child(MESSAGE_ENDPOINT)
  .orderByChild('isReceived').equalTo(false)
  .on('child_added', onNotification)
}

export const unwatchNotifications = () => {
  const uid = getState().getIn(['currentUser', 'uid'])

  if (uid) {
    const MESSAGE_ENDPOINT = USER_MESSAGE_NOTIFICATIONS_ENDPOINT(uid)

    firedux.ref.child(MESSAGE_ENDPOINT).off()
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/notifications.js
 **/